<template>
  <figure v-if="validVendor" class="logo">
    <img class="image" :src="`${$root.$data.STATIC_ROOT}images/vendor/${src}`" />
  </figure>
</template>

<style scoped>
.logo {
  display: flex;
  width: 9rem;
  height: 2.25rem;
  justify-content: start;
  align-items: center;
}

.image {
  object-fit: contain;
  max-height: 100%;
}
</style>

<script setup>
import { computed, defineProps, inject } from 'vue';

const props = defineProps({
  vendor: String,
});

const VENDORS = {
  "Zoom": "zoom.svg",
  "Google": "google-calendar.svg",
  "Google Calendar": "google-calendar.svg",
  "Outlook": "microsoft-outlook.svg",
  "Outlook Calendar": "microsoft-outlook.svg",
  "Redtail": "redtail.svg",
  "Redtail Icon": "redtail-icon.svg",
  "Practifi": "practifi.png",
  "Salesforce": "salesforce.svg",
  "Wealthbox": "wealthbox.svg",
  "Wealthbox Icon": "wealthbox-icon.svg",
  "Altruist": "altruist.svg",
}

const validVendor = computed(() => !!VENDORS[props.vendor]);

const src = computed(() => {
  return validVendor.value
    ? VENDORS[props.vendor]
    : "";
});
</script>